export const mainHeaderFideliteProps = () => ({
  isFidCarrefour: {
    type: Boolean,
    required: false,
    default: false
  },
  fidelite: {
    type: Object,
    required: false,
    default: null
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  nbDefisEnCours: {
    type: Number,
    required: false,
    default: 0
  }
})


export const useMainHeaderFidelite = (props) => {
  const totalEurocora = computed(() => {
    if (!props.fidelite) {
      return 0;
    }
    return (
      parseFloat(props.fidelite.attributes.solde_euro) +
      parseFloat(props.fidelite.attributes.solde_euro_suiv ?? 0)
    );
  })

  const totalPoints = computed(() => {
    if (!props.fidelite) {
      return 0;
    }
    return (
      parseFloat(props.fidelite.attributes.solde_point) +
      parseFloat(props.fidelite.attributes.solde_point_suiv ?? 0)
    );
  })

  return { totalEurocora, totalPoints }
}